export const FINISH_TAIL_SEC = 5;

export const REPORT_INTERVAL_SEC = 15;

export const RESUME_REWIND_SEC = 5;

export function resumePosition(options: {
  progressSec: number;
  durationSec: number;
  unlocked: boolean;
  tailSec?: number;
  rewindSec?: number;
}): number | null {
  const { progressSec, durationSec, unlocked } = options;
  const tail = options.tailSec ?? FINISH_TAIL_SEC;
  const rewind = options.rewindSec ?? RESUME_REWIND_SEC;

  if (!unlocked || progressSec <= 0) {
    return null;
  }

  if (durationSec > 0 && progressSec >= durationSec - tail) {
    return null;
  }

  const at = progressSec - rewind;

  return at > 0 ? at : null;
}

export function clampToTrial(
  currentSec: number,
  trialSeconds: number,
): { blocked: boolean; seekTo: number } {
  if (trialSeconds <= 0 || currentSec < trialSeconds) {
    return { blocked: false, seekTo: currentSec };
  }

  return { blocked: true, seekTo: trialSeconds };
}

export function shouldReport(
  currentSec: number,
  lastReportedSec: number,
  intervalSec = REPORT_INTERVAL_SEC,
): boolean {
  return Math.abs(currentSec - lastReportedSec) >= intervalSec;
}

export function isFinished(
  currentSec: number,
  durationSec: number,
  tailSec = FINISH_TAIL_SEC,
): boolean {
  return durationSec > 0 && currentSec >= durationSec - tailSec;
}
